/**
 * 참고 : https://github.kakaocorp.com/kakaopage/karina/blob/e690ed00a0475468241aa453d4dbb4ba675245b1/modules/karina-core/src/main/kotlin/com/kakaopage/karina/model/enums/BadgeType.kt#L3
 */
export enum BadgeTypeVo {
  /**
   * @deprecated
   */
  Hot = 'BT01',
  Up = 'BT02',
  New = 'BT03',
  /**
   * @deprecated
   */
  Only = 'BT04',
  /**
   * @deprecated
   */
  Free = 'BT05',
  /**
   * 에디터 추천
   * @deprecated
   */
  EditorRecomend = 'BT06',
  /**
   * 50% 할인
   * @deprecated
   */
  Discount50 = 'BT07',
  /**
   * @deprecated
   * 대여
   */
  Rental = 'BT08',
  /**
   * 휴재
   * @deprecated
   */
  Rest = 'BT09',
  /**
   * @deprecated
   */
  Top = 'BT10',
  /**
   * @deprecated
   */
  Event = 'BT11',
  /**
   * @deprecated
   */
  Waitfree = 'BT12',
  /**
   * 선택안함
   * @deprecated
   */
  NonSelected = 'BT99',
}
